function Navbar() {
    return (
        <nav className="main-header navbar navbar-expand-md navbar-light navbar-white">
            <div className="container">
                <a href="" className="navbar-brand">
                    <div className="logo-retailer"/>
                </a>
            </div>
        </nav>
    );
}

export default Navbar;
